import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from '../components/SectionContent'

const ipadImg = require('../../assets/img/fh_ipad.png')

const controlData = [
  {
    title: "Equipment",
    list: [
      "Real-time view of equipment and input states",
      "Automatic tracking and logging of equipment run times",
      "Remote control of all climate components and equipment"
    ]
  },
  {
    title: "Sensors",
    list: [
      "Real-time readings of hydro and climate sensors",
      "Automatic logging of all sensor and equipment data",
      "Historical graphs of data in the dashboard"
    ]
  },
  {
    title: "Alerts",
    list: [
      "Get alerts when any sensor  values fall above or below your acceptable range",
      "Be notified if any equipment turns off or if problems arise that need your attention"
    ]
  }
]

class ControlBlock extends React.Component {
  static propTypes: {
    title: PropTypes.string,
    list: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = { hover: false }
  }
  mouseOut() {
    this.setState({ hover: false })
  }
  mouseOver() {
    this.setState({ hover: true, className: 'active' })
  }
  render() {
    const { title, list } = this.props
    const { hover } = this.state

    return (
      <li onMouseOut={() => this.mouseOut()} onMouseOver={() => this.mouseOver()} className={hover ? 'active' : null}>
        <h5 className="text-green">{title}</h5>
        {list.map((value, key) => {
          return (
            <p key={key}>{value}</p>
          )
        })}
      </li>
    )
  }
}

class Control extends React.Component {
  render() {
    return (
      <section className="bg-light" id="control">
        <div className="container">
          <SectionHeader
            headerColor="text-green"
            headerContent="Real-Time Monitoring and Control"
            subheaderColor="text-gray"
            subheaderContent="With real-time monitoring and controlling capabilities, farmhand gives you the peace of mind you need while growing."
          />
          <article className="tablet-graphic">
            <img src={ipadImg} />
            <ul>
              {controlData.map((value, key) => {
                return (
                  <ControlBlock title={value.title} list={value.list} key={key} />
                )
              })}
            </ul>
          </article>
        </div>
      </section>
    )
  }
}

export default Control



// WEBPACK FOOTER //
// ./containers/Control.js